module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.basketRights) ? _c('div', {
    staticClass: "basketContainer iBlock vMid rel"
  }, [_c('div', {
    staticClass: "basketMenu iBlock vMid pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleMenuState();
      }
    }
  }, [_c('span', {
    staticClass: "countBasket"
  }, [_vm._v(_vm._s(_vm.countAllBaskets))]), _vm._v(" "), _c('span', {
    staticClass: "basketMenuTitle rel"
  }, [_c('span', {
    staticClass: "panel"
  }, [_vm._v(_vm._s(_vm.$t("basketMenu.menuTitle")))]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-shopping-basket"
  })])]), _vm._v(" "), (_vm.menuIsOpened) ? _c('BasketWindow') : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a917f4d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasketMenu/BasketMenu.vue
// module id = 3338
// module chunks = 0